import * as clientConfig from './client';
import { UpsellCell } from './client/types';
import { Cell, Clients, MARKET_SLIDES, Product, SlidesByType } from './constants';

const NOT_EXISTING_CLIENT_ID = '999999999';
export const INDUSTRY_CLIENT_ID = '999999990';
export const RETAIL_CLIENT_ID = '999999910';
export type Slide = {
  //needs to be changed
  headline: any;
  component: () => React.ReactElement;
};

type ConfigByClient = {
  [key in Partial<Clients>]?: UpsellCell;
};

type UpsellCellsConfig = {
  [key in Product]: ConfigByClient;
};

export const ProdishClientsConfig: { id: string; key: Clients }[] = [
  {
    id: NOT_EXISTING_CLIENT_ID,
    key: Clients.EXAMPLE_CLIENT,
  },
];

export const NonProdishClientsConfig: { id: string; key: Clients }[] = [
  {
    id: NOT_EXISTING_CLIENT_ID,
    key: Clients.EXAMPLE_CLIENT,
  },
  {
    id: '45956',
    key: Clients.AAAATEST,
  },
  {
    id: '180607',
    key: Clients.ConsumerLostShopperDevUpsell,
  },
  {
    id: '21880',
    key: Clients.ConsumerLostShopperStablUpsell,
  },
];

export const ProdishRIClientsConfig: { id: string; key: Clients }[] = [
  {
    id: NOT_EXISTING_CLIENT_ID,
    key: Clients.EXAMPLE_CLIENT,
  },
];

export const NonProdishRIClientsConfig: { id: string; key: Clients }[] = [
  {
    id: NOT_EXISTING_CLIENT_ID,
    key: Clients.EXAMPLE_CLIENT,
  },
  {
    id: '45956',
    key: Clients.AAAATEST,
  },
  {
    id: '180607',
    key: Clients.ConsumerLostShopperDevUpsell,
  },
  {
    id: '21880',
    key: Clients.ConsumerLostShopperStablUpsell,
  },
  {
    id: '184207',
    key: Clients.ConsumerRetailLostShopperDevUpsell,
  },
];

export const AllMarketSlidesPerMarket: UpsellCell = Object.values(Cell).reduce(
  (res, cell) => ({
    ...res,
    [cell]: {
      [SlidesByType.DEFAULT]: MARKET_SLIDES,
    },
  }),
  {} as UpsellCell
);

export const UpsellConfig: UpsellCellsConfig = {
  [Product.Market]: {
    [Clients.EXAMPLE_CLIENT]: clientConfig.EXAMPLESlidesPerMarket,
    [Clients.ConsumerLostShopperDevUpsell]: clientConfig.ConsumerLostShopperStoriesSlidesPerMarket,
    [Clients.ConsumerLostShopperStablUpsell]: clientConfig.ConsumerLostShopperStoriesSlidesPerMarket,
    [Clients.AAAATEST]: AllMarketSlidesPerMarket,
  },
  [Product.Retail]: {
    [Clients.EXAMPLE_CLIENT]: clientConfig.EXAMPLESlidesPerMarket,
    [Clients.ZOZOMI]: clientConfig.ConsumerLostShopperStoriesSlidesPerMarket,
    [Clients.ConsumerLostShopperDevUpsell]: clientConfig.ConsumerLostShopperStoriesSlidesPerMarket,
    [Clients.ConsumerLostShopperStablUpsell]: clientConfig.ConsumerLostShopperStoriesSlidesPerMarket,
    [Clients.ConsumerRetailLostShopperDevUpsell]: clientConfig.ConsumerRetailLostShopperStoriesSlidesPerMarket,
    [Clients.ConsumerRetailLostShopperStableUpsell]: clientConfig.ConsumerRetailLostShopperStoriesSlidesPerMarket,
    [Clients.RetailClient]: clientConfig.ConsumerRetailLostShopperStoriesSlidesPerMarket,
  },
  [Product.Consumer]: {},
  [Product.Predict]: {},
  [Product.Market4x]: {},
  [Product.Market6x]: {},
};
